// extracted by mini-css-extract-plugin
export default {"init":"admin_init__esHHd","withdraw":"admin_withdraw__wYRT8"};